import { useState } from "react";
import OtpInput from "../../../helbest/OtpInput/OtpInput";
import { CountDown, Note } from "../../../helbest";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useMutation } from "@apollo/client";
import {
  LoginMutation,
  SendOTPMutation,
} from "../../../graphql/none_saleor/auth/auth";
import {
  calculator,
  getMetadataValueByKey,
  showAllErrors,
} from "../../../base/utils";
import {
  _final_login_user,
  _login_user,
  _set_channel,
  set_checkout_id,
  _set_channel_claimed,
  _set_pending_channel,
  _set_pending_cid,
  _set_pending_cpid,
  set_cid,
  set_cpid,
} from "../../../store/actions/login_actions";
import styles from "./PromoModal.module.scss";
import { Button } from "antd";
import ResendOTPPromo from "./ResendOTPPromo";
import { set_otp_service } from "../../../store/actions/otp_action";
import { _Cart_Clean } from "../../../store/actions/cart_actions";
import { useSearchParams } from "react-router-dom";
import { BaseChannel } from "../../../base/env";

const OTPPromo = ({ setStep, availableOtp, setIsVisible }) => {
  const [otp, setOtp] = useState("");
  const [activeResendCode, setActiveResendCode] = useState(false);
  const [isResend, setIsResend] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const {
    country_code,
    phone_number,
    cid,
    cpid,
    channel,
    urlCode,
    pendingChannel,
    pendingCid,
    pendingCpid,
  } = useSelector((state) => state.Login);
  const { otpService } = useSelector((state) => state.Otp);

  const effectiveCid = pendingCid || cid;
  const effectiveCpid = pendingCpid || cpid;

  const onInput = (value) => {
    setOtp(value.join(""));
  };

  const onChange = (value) => {
    check_code(value);
  };

  const resetCountdown = () => {
    setResetKey((prev) => prev + 1);
  };

  const [loginMutation] = useMutation(LoginMutation, {
    context: {
      // headers: {
      //   "site-url": "garajmall.com",
      // },
      clientName: "auth",
    },
  });
  const [sendOtpMutation] = useMutation(SendOTPMutation, {
    context: {
      // headers: {
      //   'site-url': 'dev.higaraj.com'
      // },
      clientName: "auth",
    },
  });

  const check_code = (otpCode) => {
    if (otpCode === "") {
      Note.error(t("sendOtp.errors.empty"));
      return;
    }
    if (otpCode.length === 6) {
      loginMutation({
        variables: {
          phoneNumber: phone_number,
          countryCode: country_code,
          otp: otpCode,
          messagingService: otpService,
        },
        onCompleted: (data) => {
          if (!data.login.errors.length) {
            const emailAddress = getMetadataValueByKey(
              data.login?.user?.metadata,
              "email",
            );

            dispatch(
              _login_user({
                first_name: data.login?.user?.firstName || "",
                last_name: data.login?.user?.lastName || "",
                email: data.login?.user?.email,
                user_id: data.login?.user?.id,
                token: data.login.token,
                refreshToken: data.login.refreshToken,
                credit: 0,
                emailAddress: emailAddress ?? "",
                phone_number: phone_number,
                countryCode: country_code,
                country_code: country_code,
              }),
            );
            dispatch(_final_login_user());
            dispatch(
              _set_channel_claimed(
                pendingChannel || channel || BaseChannel,
                pendingCpid || cpid,
                pendingCid || cid,
              ),
            );
            dispatch(_Cart_Clean());
            dispatch(set_checkout_id({ checkout_id: "" }));
            calculator();
            setIsVisible(false);
          } else {
            showAllErrors(data.login.errors);
          }
        },
      });
    } else {
      Note.error(t("sendOtp.errors.invalid"));
    }
  };

  const [searchParams] = useSearchParams();

  const platform = searchParams.get("platform");

  const resendOtpCode = (service) => {
    setActiveResendCode(false);
    sendOtpMutation({
      variables: {
        phoneNumber: phone_number,
        countryCode: country_code,
        messagingService: service,
        cid: effectiveCid || null,
        cpid: effectiveCpid,
        urlCode: urlCode || null,
        platform,
        channelSlug: pendingChannel || BaseChannel,
      },
      onCompleted: (response) => {
        if (!response.sendOtp.errors.length) {
          Note.success(t("sendOtp.send_message"));
        } else {
          showAllErrors(response.sendOtp.errors);
          const hasCidError = response.sendOtp.errors.some(
            (err) => err.field === "cid",
          );
          if (hasCidError) {
            localStorage.removeItem("cid");
            localStorage.removeItem("cpid");
            localStorage.removeItem("channel");
            dispatch(set_cid(""));
            dispatch(set_cpid("gmall"));
            dispatch(_set_channel(BaseChannel, channel));
            dispatch(_set_pending_channel(""));
            dispatch(_set_pending_cpid(""));
            dispatch(_set_pending_cid(""));
            setIsVisible?.(false);
          }
        }
      },
    });
  };

  return (
    <div>
      {!isResend ? (
        <>
          <OtpInput value={otp} onInput={onInput} onChange={onChange} />
          <div className={styles.otpActions}>
            <Button
              color="default"
              variant="filled"
              data-testid="re-send"
              disabled={!activeResendCode}
              onClick={() => setIsResend(true)}
              style={{
                borderRadius: "100px",
                color: "#7F7F7F",
                height: 36,
                border: "none",
                fontWeight: !activeResendCode ? "normal" : "bold",
              }}
            >
              {t("sendOtp.re-send")}
              {!activeResendCode ? (
                <div className={styles.OtpCountDown}>
                  <CountDown
                    key={resetKey}
                    className="page-login-counter"
                    time={120000}
                    onTimeUp={() => {
                      setActiveResendCode(true);
                    }}
                  />
                </div>
              ) : null}
            </Button>
            <button
              className={styles.changePhoneNumber}
              onClick={() => {
                setStep("phone");
              }}
              type="button"
            >
              {t("sendOtp.change_mobile")}
            </button>
          </div>
        </>
      ) : (
        <ResendOTPPromo
          options={availableOtp}
          onSelect={(service) => {
            dispatch(set_otp_service(service.value));
            resetCountdown();
            resendOtpCode(service.value);
            setIsResend(false);
          }}
          setIsResend={setIsResend}
        />
      )}
    </div>
  );
};

export default OTPPromo;
